import {settingsForm as settingsForm_} from './settings-form/settings-form'

export const settingsForm = settingsForm_



// WEBPACK FOOTER //
// ./src/3rd party integration/wentworthadvantage/wentworthadvantage.ts